import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import useRefresh from '@op/hooks/useRefresh';
import { getStreamingDirectoryInfo } from '@op/services';
import { useEffect, useState } from 'react';

export function useDirectoryInfo({ filter }: { filter?: any }) {
  const [directoryInfo, setDirectoryInfo] = useState<any>({});
  const { loading, wrapperCancelRequest } = useCancelRequestHook({
    clear: () => setDirectoryInfo([]),
  });

  async function requestDirectoryInfo(loadingFlag?: boolean) {
    try {
      const data = await wrapperCancelRequest(
        getStreamingDirectoryInfo,
        filter,
        loadingFlag,
        {
          user_cache_expire: 5,
        },
      );
      setDirectoryInfo(data);
    } catch {}
  }

  const {
    initTimer,
    date: time,
    addRefreshTask,
  } = useRefresh({
    key: 'real_time_streaming_refresh_time',
  });

  useEffect(() => {
    if (filter?.edition_unified_id) {
      initTimer();
      requestDirectoryInfo();
      addRefreshTask('streamingTable', () => requestDirectoryInfo(true));
    }
  }, [filter]);

  return {
    loading,
    directoryInfo,
    refetch: requestDirectoryInfo,
    time,
  };
}
